// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/logo_hocoia.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compte-rendu {
  color: #545151;
  font-size: 0.75rem;
  padding: 1.25rem;
  font-family: "Omnes", sans-serif;
  font-weight: 500;
}
.compte-rendu p {
  margin: 0px 0px 0.5rem;
}
.compte-rendu hr {
  margin: 0.25rem 0px;
  color: #00666F;
  border: none;
  border-bottom: 1px solid #00666F;
}
.compte-rendu img {
  max-width: 100%;
  margin-bottom: 0.5rem;
}
.compte-rendu__row {
  display: flex;
  flex-wrap: nowrap;
  gap: 1.75rem;
}
.compte-rendu__left {
  flex: 0 0 65%;
}
.compte-rendu__right {
  flex: 1 1;
}
.compte-rendu__title {
  color: #00666F;
  margin: 0px 0px 0.5rem;
  padding: 0px 0px 0.5rem;
  font-family: "Filson Pro", sans-serif;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1;
  border-bottom: 1px solid #00666F;
}
.compte-rendu__logo {
  height: 1.5rem;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: contain;
}
.compte-rendu__subtitle {
  color: #00666F;
  font-family: "Filson Pro", sans-serif;
  margin: 0px 0px 0.5rem;
  padding: 0.375rem 0px 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1;
  border-bottom: 1px solid #00666F;
}
.compte-rendu__infos {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
}
.compte-rendu__info + .compte-rendu__info {
  margin-top: 0.25rem;
}
.compte-rendu__info--flex {
  display: flex;
  align-items: center;
}
.compte-rendu__box {
  background: #F4F8FD;
  padding: 0.75rem;
  border-radius: 1.5rem;
  margin-bottom: 1.25rem;
}
.compte-rendu .label {
  font-size: 0.825rem;
  color: #00666F;
  font-weight: 600;
}
.compte-rendu .label--block {
  display: block;
}
.compte-rendu .label--icon {
  font-size: 1.125rem;
  margin-right: 0.375rem;
}
.compte-rendu__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 0.125rem 1.25rem;
  color: #00666F;
}
.compte-rendu__help {
  margin: 0.5rem 0px;
  font-family: "Filson Pro", sans-serif;
  flex: 0 0 100%;
  text-align: center;
}
.compte-rendu__email, .compte-rendu__tel {
  margin: 0.5rem 0px;
}
.compte-rendu__email [class^=icon-], .compte-rendu__tel [class^=icon-] {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/CompteRendu.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCCkCiB;EDjCjB,gBAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;AAIE;EACE,mBAAA;EACA,cCIkB;EDHlB,YAAA;EACA,gCAAA;AAFJ;AAIE;EACE,eAAA;EACA,qBAAA;AAFJ;AAKE;EACE,aAAA;EACA,iBAAA;EACA,YAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,SAAA;AALJ;AAQE;EACE,cCpBkB;EDqBlB,sBAAA;EACA,uBAAA;EACA,qCCFY;EDGZ,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AANJ;AASE;EACE,cAAA;EACA,WAAA;EACA,oEAAA;EACA,wBAAA;AAPJ;AAUE;EACE,cCtCkB;EDuClB,qCClBY;EDmBZ,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AATJ;AAaI;EACE,mBAAA;AAXN;AAcI;EACE,aAAA;EACA,mBAAA;AAZN;AAgBE;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAdJ;AAmBE;EACE,mBAAA;EACA,cC5EkB;ED6ElB,gBAAA;AAjBJ;AAmBI;EACE,cAAA;AAjBN;AAoBI;EACE,mBAAA;EACA,sBAAA;AAlBN;AA0BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,cCpGkB;AD4EtB;AA0BE;EACE,kBAAA;EACA,qCCnFY;EDoFZ,cAAA;EACA,kBAAA;AAxBJ;AA0BE;EAEE,kBAAA;AAzBJ;AA0BI;EACE,oBAAA;AAxBN","sourcesContent":["@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n.compte-rendu {\n  color: #545151;\n  font-size: 0.75rem;\n  padding: 1.25rem;\n  font-family: $font__quaternary;\n  font-weight: 500;\n\n  p {\n    margin: 0px 0px 0.5rem;\n  }\n  hr {\n    margin: 0.25rem 0px;\n    color: $color__primary-dark;\n    border: none;\n    border-bottom: 1px solid $color__primary-dark;\n  }\n  img {\n    max-width: 100%;\n    margin-bottom: 0.5rem;\n  }\n\n  &__row {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 1.75rem;\n  }\n\n  &__left {\n    flex: 0 0 65%;\n  }\n\n  &__right {\n    flex: 1 1;\n  }\n\n  &__title {\n    color: $color__primary-dark;\n    margin: 0px 0px 0.5rem;\n    padding: 0px 0px 0.5rem;\n    font-family: $font__ternary;\n    font-weight: 500;\n    font-size: 1.5rem;\n    line-height: 1;\n    border-bottom: 1px solid $color__primary-dark;\n  }\n\n  &__logo {\n    height: 1.5rem;\n    width: 100%;\n    background: functions.image('logo_hocoia.svg') no-repeat center;\n    background-size: contain;\n  }\n\n  &__subtitle {\n    color: $color__primary-dark;\n    font-family: $font__ternary;\n    margin: 0px 0px 0.5rem;\n    padding: 0.375rem 0px 0.375rem;\n    font-weight: 500;\n    font-size: 0.875rem;\n    line-height: 1;\n    border-bottom: 1px solid $color__primary-dark;\n  }\n\n  &__infos {\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n  }\n\n  &__info {\n    & + & {\n      margin-top: 0.25rem;\n    }\n\n    &--flex {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  &__box {\n    background: #F4F8FD;\n    padding: 0.75rem;\n    border-radius: 1.5rem;\n    margin-bottom: 1.25rem;\n  }\n\n\n  // ------------------------------------\n  .label {\n    font-size: 0.825rem;\n    color: $color__primary-dark;\n    font-weight: 600;\n\n    &--block {\n      display: block;\n    }\n    \n    &--icon {\n      font-size: 1.125rem;\n      margin-right: 0.375rem;\n    }\n  }\n\n  \n\n  // ------------------------------------\n  // FOOTER\n  &__footer {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    width: 100%;\n    justify-content: center;\n    gap: 0.125rem 1.25rem;\n    color: $color__primary-dark;\n  }\n  &__help {\n    margin: 0.5rem 0px;\n    font-family: $font__ternary;\n    flex: 0 0 100%;\n    text-align: center ;\n  }\n  &__email,\n  &__tel {\n    margin: 0.5rem 0px;\n    [class^=\"icon-\"] {\n      margin-right: 0.5rem;\n    }\n  }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
